import { useMemo } from "react"

import { DateFilterOperator } from "@tfg/types/types/date-filter.dto"

import {
  DatePickerFilterProps,
  DefaultDatePickerFilter,
  RangeDateFilterInput,
} from "../DatePickerFilter"

type ComponentOperatorMapping = {
  operators: DateFilterOperator[]
  component: React.ReactNode
}

export const useComponentOperatorMapping = ({
  locale,
  dateRange,
  onChange,
}: DatePickerFilterProps) => {
  const componentOperatorMapping = useMemo<ComponentOperatorMapping[]>(() => {
    return [
      {
        operators: [
          DateFilterOperator.BETWEEN,
          DateFilterOperator.IS_NOT_BETWEEN,
        ],
        component: (
          <RangeDateFilterInput
            locale={locale}
            dateRange={dateRange}
            onChange={onChange}
          />
        ),
      },
      {
        operators: [
          DateFilterOperator.EQUALS,
          DateFilterOperator.BEFORE,
          DateFilterOperator.AFTER,
          DateFilterOperator.NOT_EQUALS,
          DateFilterOperator.IS_BEFORE_OR_EQUALS,
          DateFilterOperator.IS_AFTER_OR_EQUALS,
        ],
        component: (
          <DefaultDatePickerFilter
            locale={locale}
            dateRange={dateRange}
            onChange={onChange}
          />
        ),
      },
      {
        operators: [
          DateFilterOperator.IS_EMPTY,
          DateFilterOperator.IS_NOT_EMPTY,
        ],
        component: null,
      },
    ]
  }, [locale, dateRange, onChange])

  return componentOperatorMapping
}
